import Box from '@mui/material/Box';
import Grid from '@material-ui/core/Grid';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import clsx from 'clsx';
import { forwardRef, useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from './InfoProduct.module.css';
import { replaceImgSrc } from '../PcScreen/SectionInformation/SectionInformation.util';

interface Props {
  className?: string;
  product: any;
  onClickBait: () => void;
}

// this is a clone component
// need to refactor, build a new component

const InfoProduct = forwardRef<HTMLDivElement, Props>(function InfoProduct({ className, product, onClickBait }, ref) {
  const { contraindication, dosage, drugInteraction, drugOverdose, indication, storage } = product?.description;

  const parentRef = useRef<HTMLDivElement>(null);
  const [isDisplaySecondTab, setIsDisplaySecondTab] = useState(false);
  const [ingredientEle, setIngredientEle] = useState<JSX.Element[]>([]);

  const isHtmlStringEmpty = (htmlString: string): boolean => {
    if (!htmlString) return true;

    // Remove whitespace characters and tags using a regular expression
    const cleanString = htmlString?.replace(/<[^>]*>/g, '').replace(/\s/g, '');

    // Check if the cleaned string is empty or contains only <br> tags
    return cleanString?.length === 0 || /^<br>+$/.test(cleanString);
  };

  const handleShowHide = () => {
    if (parentRef?.current) {
      parentRef.current.style.height = `100%`;
    }
  };
  const handleChange = (e: React.ChangeEvent<{}>, newValue: string): void => {
    if (newValue === '2') {
      onClickBait();
    }
  };

  useLayoutEffect(() => {
    handleShowHide();
  }, []);

  useEffect(() => {
    setIsDisplaySecondTab(!isHtmlStringEmpty(indication || drugInteraction || drugOverdose || contraindication || dosage || storage));

    (async () => {
      if (product.ingredients?.length > 0) {
        const newIngredientEle = product.ingredients?.map(
          ({ volume: ingredientVolume, name: ingredientName = '', slug }: { volume: string; name: string; slug: string }) => {
            return (
              <div
                key={slug}
                style={{ display: 'flex', justifyContent: 'space-between' }}
                className={clsx(styles.groupIngredient, styles?.groupIngredientIsNotLogin)}
              >
                <Typography className={`${styles.ingredientLink}`}>{ingredientName}</Typography>

                <span className={styles.ingredientVolume}>{ingredientVolume}</span>
              </div>
            );
          },
        );
        setIngredientEle([...newIngredientEle]);
      } else {
        setIngredientEle([]);
      }
    })();
  }, [product.ingredients]);

  return (
    <div ref={ref}>
      <div className={clsx(styles.container, className)} ref={parentRef}>
        <TabContext value="1">
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList className={styles.tabList} onChange={handleChange} TabIndicatorProps={{ style: { background: 'var(--primary-color)' } }}>
              <Tab label="Thông tin chung" value="1" />
              {isDisplaySecondTab ? <Tab label="Thông tin chuyên sâu" value="2" /> : <></>}
            </TabList>
          </Box>
          <TabPanel className={clsx(styles.tabPanelCustom)} value="1">
            <Grid container className={styles.paddingCustom}>
              <Grid item lg={6} sm={12} className={clsx(styles.leftContentNotLogin, styles.leftSideNotLogin)}>
                <div className={styles.wrapperInfo}>
                  <Typography className={styles.infoNotLogin}>Thông tin</Typography>
                  <div
                    className={styles.contentNotLogin}
                    dangerouslySetInnerHTML={{
                      __html: replaceImgSrc(product?.description?.description),
                    }}
                  />
                </div>
              </Grid>
              <Grid item lg={6} sm={12} className={clsx(styles.rightContentNotLogin)}>
                <div className={styles.wrapperInfo}>
                  <Typography className={styles.infoNotLogin}>Thành phần</Typography>
                  {ingredientEle?.length > 0 && ingredientEle?.map((item) => item)}
                </div>
              </Grid>
            </Grid>
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
});

export default InfoProduct;
